import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-809">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-810">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-811">
          <div className="md:col-span-2" data-id="element-812">
            <Link to="/" className="inline-block mb-4" data-id="element-813">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-814" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-815">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-816">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-817">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-818">
              <li data-id="element-819">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-820">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-821">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-822">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-823">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-824">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-825">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-826">
              <li className="flex justify-between" data-id="element-827">
                <span data-id="element-828">{t('footer.monFri')}</span>
                <span data-id="element-829">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-830">
                <span data-id="element-831">{t('footer.saturday')}</span>
                <span data-id="element-832">6:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-833">
                <span data-id="element-834">{t('footer.sunday')}</span>
                <span data-id="element-835">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-836">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-837">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-838">
              <li data-id="element-839">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-840">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-841">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-842">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-843">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-844">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-845">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-846">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-847">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-848">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-849">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-850">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-851">
          <p data-id="element-852">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-853">
            <a href="#" className="hover:text-white transition-colors" data-id="element-854">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-855">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-856" />

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                      the site. Forest-green background, black text. */}
      <div className="w-full bg-[#176F17]" data-id="element-857">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide" data-id="element-858">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] text-black shrink-0 font-[700]" data-id="element-859">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors font-[500] text-black shrink-0" data-id="element-860">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors font-[500] text-black shrink-0" data-id="element-861">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors font-[500] text-black shrink-0" data-id="element-862">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}